import { useSelector } from 'react-redux';

import { CHATBOT_ID } from '../constants/chatbotId';
import { chatbotSelector, currentOpenChatSelector } from '../selectors';
import { findLastMessage } from '../utils/findLastMessage';

export enum EChatbotButtons {
  AnswerQuestions = 'answerQuestions',
  ShowAll = 'showAll',
  StopSearch = 'stopSearch',
  SendMore = 'sendMore',
  NewSearch = 'newSearch',
  TunePeriodicity = 'tunePeriodicity',
}

/**
 * Хук для определения порядка кнопок помогатора
 */
export const useChatbotButtons = (isChatbotGPTEnabled: boolean): EChatbotButtons[] => {
  const { hasPollAnswers, periodicity, isPeriodicityMenuOpened } = useSelector(chatbotSelector);
  const currentChat = useSelector(currentOpenChatSelector);

  if (currentChat?.chatId !== CHATBOT_ID || isChatbotGPTEnabled) {
    return [];
  }

  const messagesLength = currentChat.chatMessages.length || 0;

  const lastMessage = findLastMessage({
    chat: currentChat,
    messageIndex: messagesLength - 1,
  });

  if (messagesLength === 1 || !lastMessage) {
    return [EChatbotButtons.AnswerQuestions];
  }

  if (!hasPollAnswers) {
    if (lastMessage.fromCrm) {
      return [EChatbotButtons.ShowAll, EChatbotButtons.AnswerQuestions, EChatbotButtons.StopSearch];
    }

    return [EChatbotButtons.ShowAll, EChatbotButtons.NewSearch];
  }

  if (periodicity === 'never') {
    return [EChatbotButtons.SendMore, EChatbotButtons.NewSearch];
  }

  if (isPeriodicityMenuOpened) {
    return [EChatbotButtons.TunePeriodicity];
  }

  return [
    EChatbotButtons.SendMore,
    EChatbotButtons.NewSearch,
    EChatbotButtons.TunePeriodicity,
    EChatbotButtons.StopSearch,
  ];
};
